// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
// JS Imports
import { formatFloatAsCurrencySymbol } from '../../../common/helpers.mjs'
// Asset Imports

export default function TotalPayrollRow() {
   const state = useQuoteContext()
   const { getString } = state

   if (
      state.user_view == 'Internal' ||
      (state.payrollMonthlyTotal.totalPrice || 0) +
         (state.alwaysUSDMonthlyTotal?.totalPrice || 0) >
         0
   )
      return (
         <div className='row grey-bold'>
            <div className='col-bhr1 col-bhr5'>
               <span>{getString('product.TotalPayrollRow.Title')}</span>
            </div>
            <div className='col'>
               {(state.product_list[state.coreProductSelected][
                  'MinimumEmployees'
               ] > state.productCoreEECount &&
                  state.productCoreEECount > 0) ||
               (state.product_list['payroll']['MinimumEmployees'] >
                  state.productPayrollTotalEECount &&
                  state.productPayrollTotalEECount > 0) ||
               (state.product_list['benAdmin']['MinimumEmployees'] >
                  state.productBenefitsAdministrationEECount &&
                  state.productBenefitsAdministrationEECount > 0) ? (
                  ''
               ) : (
                  <span>
                     {formatFloatAsCurrencySymbol(
                        state.payrollMonthlyTotal.discountedPEPMCost,
                        state.currencyObjectUSD,
                     )}
                  </span>
               )}
            </div>
            <div className='col'></div>
            <div className='col'>
               <span>
                  {formatFloatAsCurrencySymbol(
                     (state.payrollMonthlyTotal.totalPrice || 0) +
                        (state.alwaysUSDMonthlyTotal?.totalPrice || 0),
                     state.currencyObjectUSD,
                  )}
               </span>
            </div>
         </div>
      )
}
